import{ref as o}from"vue";function useKeyboardOnlyFocus(){const e=o(!1);let u=!1;const s={mousedown:()=>{u=!0},focus:()=>{u||(e.value=!0),u=!1},blur:()=>{e.value=!1,u=!1}};return{hasKeyboardFocus:e,keyboardFocusListeners:s}}export{useKeyboardOnlyFocus as u};
//# sourceMappingURL=useKeyboardOnlyFocus.js.map
